export const selectProgramName = (program) =>
    program.program.programname;
